import React from 'react';
import { ChatUIEnhancementCategoryCard } from 'Assistant/__generated__/client.schemas';
import { CategoryCardWrapper, CategoryCardsRow } from '../styles';
import { CategoryPill } from '.';

type CategoryPillsGroupProps = {
  group: { kind: 'category_card'; value: ChatUIEnhancementCategoryCard }[];
  groupStartKey: number | string;
};

const CategoryPillsGroup = ({
  group,
  groupStartKey,
}: CategoryPillsGroupProps) => (
  <CategoryCardsRow key={`category-row-${groupStartKey}`}>
    {group.map((c, idx) => (
      <CategoryCardWrapper key={`${groupStartKey}-${idx}`}>
        <CategoryPill value={c.value} />
      </CategoryCardWrapper>
    ))}
  </CategoryCardsRow>
);

export default CategoryPillsGroup;
